var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270 1717 l0 -134 -117 -6 c-184 -10 -308 -50 -399 -130 -26 -23 -75 -85 -109 -137 -73 -113 -149 -184 -219 -205 -33 -10 -95 -15 -188 -15 l-138 0 0 -89 0 -89 163 -4 c126 -2 169 -7 192 -20 61 -33 130 -105 190 -198 67 -104 130 -166 202 -200 76 -36 191 -60 311 -67 l112 -6 0 -134 c0 -73 2 -133 4 -133 9 0 611 351 614 358 2 6 -572 345 -610 360 -4 2 -8 -58 -8 -133 l0 -137 -82 7 c-164 13 -262 39 -312 83 -10 9 -47 60 -81 112 -34 52 -87 119 -119 148 l-56 53 57 52 c31 29 84 95 118 147 34 52 71 103 81 112 50 44 148 70 311 83 l82 7 3 -136 3 -136 308 177 c169 98 306 181 305 185 -3 7 -605 358 -614 358 -2 0 -4 -60 -4 -133z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.9fc9325a24268ad00515d515dcdb4edf.svg";
export { ForwardRef as ReactComponent };